import { ActionButton } from '@eastcoal/common/components/Button/ActionButton'
import { pick } from '@eastcoal/common/utils/object'

import { SubmitType } from '../../enums/SubmitType'
import { useCrudFormStore } from '../../Store/hooks/useStore'
import { useKeeponButton } from '../hooks/useKeeponButton'

import { SubmitButtonProps } from './interface'

export const SubmitButton = ({
  keepon,
  forceShow,
  type: externalType,
  icon: externalIcon,
  children: externalChildren,
  ...restProps
}: SubmitButtonProps) => {
  const { form, submitLoading, submit } = useCrudFormStore(state =>
    pick(state, ['form', 'submitLoading', 'submit'])
  )

  const handleSubmit = async () => {
    await submit({ submitType: SubmitType.SUBMIT, keepon })
    if (keepon) {
      form.reset()
    }
  }

  const { type, ghost, icon, children, hide } = useKeeponButton({
    keepon,
    forceShow,
    type: externalType,
    icon: externalIcon,
    children: externalChildren
  })

  return hide ? null : (
    <ActionButton
      ghost={ghost}
      htmlType='submit'
      icon={icon}
      loading={submitLoading}
      type={type}
      onClick={handleSubmit}
      {...restProps}
    >
      {children}
    </ActionButton>
  )
}
